exports = module.exports = require("./../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "#intercom-container{display:none}.tick{height:7rem;width:7rem;position:relative;margin:0 auto}@media (max-width:599px){.tick{height:5rem;width:5rem}}.layerOne{fill:#e8f1ce}.layerTwo{fill:none;stroke:#99c63d;stroke-width:8;stroke-linejoin:round;stroke-miterlimit:10}.layerThree{fill:#99c63d}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?localIdentName=[local]--[hash:base64:8]!./~/sass-loader!./src/components/shared/tick/styles.scss
// module id = 1037
// module chunks = 0